<template>
  <div class="container">
    <My-Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="detail-wrapper">
      <div v-if="modules.length == 0" class="no-data">暂无数据...</div>
      <div class="options">

        <div class="option-card" v-for="item in modules" :key="item.key">
          <div class="body">
            <div class="header">
              <div class="header-info">
                <div class="header-info-title">{{ item.title }}</div>
                <div class="header-info-price">￥{{ item.price }}/年</div>
              </div>
              <div class="header-rigth" @click="showExampleFn(item)">
                查看详情
              </div>
            </div>
            <div class="body-content">
              <div>{{ item.scene }}</div>
            </div>
            <div style="width: 100%;background-color: #eee;height: 120px;margin-top: 10px;">
              <img :src="item.image" style="width: 100%;height: 120px;object-fit: unset;">
            </div>
          </div>

          <div class="bottom" v-if="item.selected == true">
            <div class="button">
              已开通
            </div>
          </div>

          <div class="bottom-un" v-else="item.selected">

            <router-link target="_blank" :to="{ path: '/VersionInformation', query: { id: item.id } }"
              style="color:#000;">立即开通</router-link>

          </div>
        </div>

        <!-- <div style="font-size: 18px;font-weight: 800;">硬件及调试服务</div> -->
      </div>
    </div>

    <!-- 配置示例 -->
    <a-modal v-model="showExample" :title="exampleTitle" :width="600" :footer="null">
      <div style="width:100%;height:100%;overflow:auto;" v-html="example"></div>
      <!-- <vue-editor v-model="example" useCustomImageHandler /> -->
    </a-modal>
  </div>
</template>

<script>
import { getModules, getPolicy } from "@/request/api";
import util from "@/utils/util";

import MyBreadcrumb from "@/components/common/MyBreadcrumb.vue";

export default {
  data() {
    return {
      breadcrumbs: [
        {
          key: 0,
          title: "更多功能",
        },
        {
          key: 0,
          title: "功能开通",
        },
      ],
      query: {},
      options: [],
      showExample: false,
      example: "",
      exampleTitle: "",
      modules: {},
      serviceContent: '',
      privacyContent: ''
    };
  },
  computed: {},
  components: {
    MyBreadcrumb,
  },
  async created() {
    // this.query = this.$route.query;
    // console.log('上个页面传进的参数')
    // console.log(this.query)
    // this.getOptions(this.query.id, this.query.version);
    // console.log(this.options);
    this.getModules();
  },
  mounted() { },
  methods: {
    goBack: util.DebounceBy(function () {
      this.$router.back()
    }, 3000),
    // 获取选项列表
    async getOptions(id, version) {
      console.log('传入的模块id：')
      console.log(id)
      try {
        let { data } = await getOptionList(id, { version });
        this.options = data.data;
      } catch (error) {
        this.$message.error(error.data.msg)
      }
    },
    async getModules() {
      let that_ = this;
      //获取用户食堂模块列表
      getModules().then((res) => {
        that_.modules = res.data.data;
      });
    },
    // 展示示例
    showExampleFn(item) {
      // console.log(item)
      let { title, scene, description } = item;
      Object.assign(this, {
        example: description ? description : '暂无...',
        exampleTitle: title,
        showExample: true,
      });
    },
    // 更新食堂信息，权限数组
    async updateAuths() {
      await this.$store.dispatch("GET_INST_INFO");
      await this.$store.dispatch("GET_ME");
      await this.$store.dispatch("GET_ALL_AUTH");
    },
    // 选用选项
    checkOption(item) {
      this.$confirm({
        title: `确定选用该选项？`,
        onOk: async () => {
          try {
            let { data } = await switchOption(item.had_id);
            this.options = data.data;
            await this.updateAuths()
            this.$message.success("操作成功");
            await this.getOptions(this.query.id, this.query.version);
          } catch (error) {
            let { data } = error,
              msg = "";
            for (let i in data.errors) {
              msg = data.errors[i][0];
            }
            this.$message.error(msg);
          }
        },
      });
    },

    // 购买选项 
    async buyOption(item) {
      // this.$router.push({
      //     path: "/VersionInformation",
      //     query: item,
      //   });
      this.$router.resolve({
        path: "/VersionInformation",
        query: { id: item.id }
      });
      this.$store.commit('UPDATE_SELECTEDKEYS', ['/VersionInformation'])
    },

    async getPolicyFn() {
      let that = this;
      let parames = {}
      getPolicy(parames).then((res) => {
        let info = res.data.data;
        that.serviceContent = info.service.content;
        that.privacyContent = info.privacy.content;
        that.rulesContent = info.UpgradeRules.content;
      })
        .catch((err) => {

        });
    }

  },
};
</script>
<style lang='less' scoped>
.container {
  .detail-wrapper {
    width: 100%;
    background-color: #fff;
    padding: 10px;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn {
        font-size: 20px;
        color: #ff833d;
      }

      .title {
        font-weight: bold;
        font-size: 20px;
        width: 100%;
        text-align: center;
      }
    }
  }

  .no-data {
    padding: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: gray;
  }

  .options {
    display: flex;
    flex-wrap: wrap;

    .option-card {
      margin: 20px;
      border-radius: 5px;
      overflow: hidden;
      min-width: 300px;
      max-width: 300px;
      width: 300px;
      border: 1px solid #f0f2f5;

      .top {
        background-color: #f0f2f5;
        height: 50px;
        flex-direction: column;

        .title {
          font-size: 15px;
        }
      }

      .body {
        height: 220px;
        /*        padding: 20px;*/
      }

      .example-wrapper {
        padding: 5px;
        display: flex;
        justify-content: flex-end;

        .example-text {
          font-size: 15px;
          font-weight: bold;
          color: #ff833d;
          cursor: pointer;
        }
      }

      .bottom {
        background-color: #f0f2f5;
        height: 40px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .button {
          width: 100%;
          height: 100%;
          line-height: 40px;
        }

        .try-option,
        .buy-option {
          width: 50%;
          height: 100%;
          line-height: 40px;
          position: relative;
        }

        .try-option::after {
          content: "";
          width: 1px;
          height: 40px;
          background: lightgray;
          position: absolute;
          right: 0;
        }
      }

      .bottom-un {
        background-color: #ff833d;
        height: 40px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .button {
          width: 100%;
          height: 100%;
          line-height: 40px;
        }

        .try-option,
        .buy-option {
          width: 50%;
          height: 100%;
          line-height: 40px;
          position: relative;
        }

        .try-option::after {
          content: "";
          width: 1px;
          height: 40px;
          background: lightgray;
          position: absolute;
          right: 0;
        }
      }
    }

    .active {
      border: 1px solid #ff833d;
    }
  }
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  height: 40px;
  overflow: hidden;
}

.header-info {
  display: flex;
  justify-content: flex-start;
  line-height: 18px;
}

.header-info-title {
  font-weight: 800;
  font-size: 16px;
}

.header-info-price {
  color: #ff833d;
  margin-left: 10px;
}

.header-rigth {}

.body-content {
  margin-top: 8px;
  padding: 0 20px;
  height: 42px;
  overflow: hidden;
}
</style>
